'use client';
import Link from 'next/link';
import { useSurveyPath } from '@/hooks/useSurveyPath';

interface CallToActionButtonContentProps {
  className?: string;
  defaultText?: string;
}

const CallToActionButtonContent = ({
  className = 'button min-w-[220px]',
  defaultText,
}: CallToActionButtonContentProps) => {
  const { path } = useSurveyPath();

  return (
    <Link className={className} href={path} prefetch>
      <strong>
        {defaultText ?? 'Jetzt abnehmen - kostenlos'}
      </strong>
    </Link>
  );
};

export default CallToActionButtonContent;
